<template>
  <div
    v-tooltip.bottom="tooltipContent"
    class="badge br-pill b-1 t-xs f-h demibold f-ac"
    :class="classes"
  >
    <div v-emoji="emoji" />
    {{ name }}
  </div>
</template>

<script setup>
import { useStore } from 'vuex';
import { computed } from 'vue';

const props = defineProps({
  product: {
    type: String,
    required: true,
    validator: (value) => ['shoutouts', 'intros', 'journeys', 'watercooler', 'celebrations', 'profiles'].includes(value.toLowerCase()),
  },
  name: {
    type: String,
    required: true,
  },
  emoji: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: null,
  },
  earnedAt: {
    type: String,
    default: null,
  },
  variant: {
    type: String,
    default: 'profile',
  },
});

const classes = computed(() => {
  const product = {
    shoutouts: 'bg-yellow-light orange',
    intros: 'bg-yellow-lighter dark-yellow',
    journeys: 'bg-red-pale error-red',
    watercoolers: 'bg-blue dark-blue',
    celebrations: 'bg-green-pale dark-green',
    profile: 'bg-light-purple dark-purple',
  };

  const variant = {
    profile: 'p-h12 p-v8 f-gap-4',
    store_listing: 'p-h18 p-v12 t-xl f-gap-8',
  };

  const productClass = product[props.product.toLowerCase()];
  const variantClass = variant[props.variant.toLowerCase()];

  return `${productClass} ${variantClass}`;
});

const { state } = useStore();

const tooltipContent = computed(() => {
  let description;
  let formattedDate;

  if (props.description) {
    description = props.description.endsWith('.') ? props.description : `${props.description}.`;
  }

  if (props.earnedAt) {
    const earnedDate = new Date(props.earnedAt);

    formattedDate = earnedDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: state.currentUser.timezone,
    });
  }

  if (formattedDate) {
    return `${description}\n\n Earned on ${formattedDate}.`;
  }

  return description;
});
</script>

<style lang="scss" scoped>
@import '../../styles/donut.scss';
.badge {
  border-color: currentColor !important;
}
</style>
